import isEmpty from 'lodash/isEmpty';
import { array, bool, number, string } from 'prop-types';
import React, { memo } from 'react';
import isAudio from 'utils/isAudio';
import isPicture from 'utils/isPicture';
import isVideo from 'utils/isVideo';
import resolvePreviewImageSrc from 'utils/resolvePreviewImageSrc';
import FileThumbnail from './FileThumbnail';
import PictureThumbnail from './PictureThumbnail';
import VideoThumbnail from './VideoThumbnail';
import VoiceMessageBubble from './VoiceMessageBubble';

const Attachments = ({
  attachments = null,
  right,
  maxWidth = null,
  maxHeight = null,
  messageId = null,
  senderName = '',
  senderAvatar = null,
}) => {
  if (isEmpty(attachments)) return null;
  if (!attachments) return null;
  if (!attachments[0]) return null;

  const pictures = attachments.filter(isPicture);
  const videos = attachments.filter(isVideo);
  const audios = attachments.filter(isAudio);
  const files = attachments.filter(a => a.mimeType && !isPicture(a) && !isVideo(a) && !isAudio(a));

  return (
    <div>
      {pictures.map(picture => {
        const previewSrc = resolvePreviewImageSrc(picture, { variant: 'preview' });
        const fullSrc = resolvePreviewImageSrc(picture, { preferHttpLink: true });
        if (!previewSrc && !fullSrc) return null;
        return (
          <PictureThumbnail
            key={picture._id}
            src={previewSrc || fullSrc}
            fullSrc={fullSrc}
            meta={picture.meta}
            maxWidth={maxWidth}
            maxHeight={maxHeight}
          />
        );
      })}
      {videos.map(video => (
        <VideoThumbnail
          key={video._id}
          data={video}
          maxWidth={maxWidth}
          maxHeight={maxHeight}
          messageId={messageId}
        />
      ))}
      {audios.map(audio => (
        <VoiceMessageBubble
          key={audio._id}
          data={audio}
          right={right}
          senderName={senderName}
          senderAvatar={senderAvatar}
        />
      ))}
      {files.map(file => (
        <FileThumbnail key={file._id} data={file} right={right} />
      ))}
    </div>
  );
};

Attachments.propTypes = {
  right: bool.isRequired,
  attachments: array,
  maxWidth: number,
  maxHeight: number,
  messageId: string,
  senderName: string,
  senderAvatar: string,
};
export default memo(Attachments);
